module.exports = __webpack_public_path__ + "img/pilice.a5a97962.png";